// 商品路由
import Layout from '@/view/layout' // 主框架
import Home from '@/view/home'

export default [
  {
    path: '/login',
    component: () => import('@/view/auth/login'),
    meta: {
      auth: false,
      type: 'admin'
    },
    name: '授權-登錄'
  },
  {
    path: '/shopadmin/login',
    component: () => import('@/view/auth/login'),
    meta: {
      auth: false,
      type: 'distributor'
    },
    name: '授權-店鋪登錄'
  },
  {
    path: '/merchant/login',
    // component: () => import( '@/view/merchantlogin' ),
    component: () => import('@/view/auth/login'),
    meta: {
      auth: false,
      type: 'merchant'
    },
    name: '授權-商戶登錄'
  },
  // {
  //   path:'/dealer/login',
  //   component:()=> import('@/view/auth/login'),
  //   meta:{
  //     auth:false
  //   },
  //   name:'授權-經銷商登錄'
  // },
  {
    path: '/shopadmin',
    redirect: '/shopadmin/login'
  },
  {
    path: '/dealer/login',
    // component:()=> import('@/view/auth/dealer_login'),
    component: () => import('@/view/auth/login'),
    meta: {
      auth: false,
      type: 'dealer'
    },
    name: '授權-經銷商登錄'
  },
  // {
  //   path: '/shopadmin/shoplist',
  //   component: () => import( '@/view/shoplist' )
  // },
  // 激活
  {
    path: '/activelicense',
    component: () => import('@/view/base/asset/accountactivation/index')
  },
  // 營銷中線跳轉銷售中心無權限
  {
    path: '/notExistAuth',
    component: () => import('@/view/notExistAuth')
  },
  // oauth登錄回調
  {
    path: '/iframeLogin',
    meta: {
      auth: false
    },
    component: () => import('@/view/base/iframeLogin')
  },
  {
    path: '/auth/:auth_type',
    component: () => import('@/view/authloading'),
    meta: {
      auth: false
    }
  },

  {
    path: '/wxapp/manage/decorate',
    name: `模組編輯`,
    component: () => import('@/view/decorate/index')
  }
]
